<template>
    <div class="editform">
        <Form
            ref="pInfo"
            :model="pInfo"
            :rules="ruleValidate"
            :label-width="70"
            :viewonly="isView"
        >
            <Row :gutter="20">
                <Col span="12">
                    <Row>
                        <Col span="24">
                            <FormItem label="姓名" prop="nickname">
                                <Input
                                    v-model="pInfo.nickname"
                                    :maxlength="32"
                                ></Input>
                            </FormItem>
                        </Col>
                        <Col span="24">
                            <FormItem label="手机号" prop="phone">
                                <Input
                                    v-model="pInfo.phone"
                                    :maxlength="32"
                                ></Input>
                            </FormItem>
                        </Col>
                    </Row>
                </Col>
                <Col span="12">
                    <FormItem label="形象照" prop="avatar">
                        <preview-upload
                            v-model="pInfo.avatar"
                            :max-number="1"
                        />
                    </FormItem>
                </Col>
            </Row>
            <Row>
                <Col span="24">
                    <FormItem label="岗位" prop="rids">
                        <form-lookup
                            v-model="pInfo.rids"
                            placeholder="请选择岗位"
                            title="选择岗位"
                            :modalHeight="480"
                            :modalWidth="480"
                            :options="orgOptions"
                        >
                            <select-org></select-org>
                        </form-lookup>
                    </FormItem>
                </Col>
            </Row>
            <Row :gutter="20">
                <Col span="24">
                    <FormItem label="园区" prop="aids">
                        <select-tree
                            v-model="pInfo.aids"
                            ref="aids"
                            :list="parkList"
                            multiple
                            fullPathName
                        ></select-tree>
                    </FormItem>
                </Col>
            </Row>
            <Row :gutter="20">
                <Col span="12">
                    <FormItem label="启用" prop="enabled">
                        <i-switch
                            v-model="pInfo.enabled"
                            size="large"
                            :true-value="1"
                            :false-value="0"
                        >
                            <span slot="open">启用</span>
                            <span slot="close">禁用</span>
                        </i-switch>
                    </FormItem>
                </Col>
            </Row>
            <Row>
                <FormItem label="说明" prop="remark">
                    <Input
                        type="textarea"
                        v-model="pInfo.remark"
                        placeholder="0/1000"
                        :rows="4"
                        :maxlength="1000"
                    ></Input>
                </FormItem>
            </Row>
        </Form>
    </div>
</template>
<script>
import mSelectAssetsPark from '@/views/common/m-select-assets-park'
import { userView, userAdd, userUpdate } from '@/api/sys-user'
import { orgList } from '@/api/sys-org'
import { assetsParkRootList } from '@/api/configuration'

import PreviewUpload from '_c/preview-upload'
import { ymd } from '_u/helper'
import SelectOrg from './select-org'

export default {
    name: 'UserForm',
    mixins: [mSelectAssetsPark],
    props: {
        id: {
            type: [String, Number],
            default: '',
        },
        actionType: {
            type: [String, Number],
            default: '',
        },
    },
    components: {
        SelectOrg,
        PreviewUpload,
    },
    inject: {
        $modal: {
            default: null,
        },
    },
    data() {
        return {
            loading: false,
            pInfo: {
                id: '',
                nickname: '',
                avatar: '',
                phone: '',
                ver: '',
                enabled: '',
                remark: '',
                rids: '',
                aids: '',
            },
            userList: [],
            parkList: [],
            modalHeight: 600,
            modalWidth: 1000,
            orgOptions: [],
            channelList: [],
            projList: [],
            isView: this.actionType === '2' ? true : false,
        }
    },

    computed: {
        ruleValidate() {
            return this.isView
                ? {}
                : {
                      nickname: [{ required: true, message: '姓名必填' }],
                      phone: [{ required: true, message: '手机号必填' }],
                      rids: [{ required: true, message: '岗位必填' }],
                      aids: [{ required: true, message: '园区必填' }],
                  }
        },
        aids: {
            get() {
                return this.pInfo.aids ? this.pInfo.aids.split(',') : []
            },

            set(val) {
                this.pInfo.aids = val.join(',')
            },
        },
    },
    methods: {
        fetch() {
            // 修改
            if (this.id) {
                return userView(this.id)
            } else {
                // 默认启用
                this.pInfo.enabled = 1
                return Promise.resolve()
            }
        },
    },
    mounted() {
        var $pInfo = this.$refs.pInfo

        this.loading = true
        // 按钮配置
        const btns = []
        if (this.isView) {
            btns.unshift({
                type: 'default',
                name: 'cancel',
                text: '关闭',
            })
        } else {
            btns.unshift({
                type: 'default',
                name: 'cancel',
                text: '取消',
            })
            btns.unshift({
                type: 'primary',
                name: 'confirm',
                text: '确定',
            })
        }
        this.$modal.updateBtns(btns)

        this.$modal.onBtnClick('confirm', (next, options) => {
            $pInfo.validate((valid) => {
                if (valid) {
                    var formData = Object.assign(
                        {
                            parkIds: this.$refs.aids
                                .getCheckedAndIndeterminateNodes()
                                .filter((v) => v.level == '1')
                                .map((v) => v.id)
                                .join(','),
                        },
                        this.pInfo
                    )

                    if (this.id) {
                        userUpdate(formData)
                            .then(
                                (res) =>
                                    this.$Message.success(
                                        this.$t('tips.update.success')
                                    ),
                                (err) => (options.closeModal = false)
                            )
                            .then((res) => next())
                    } else {
                        delete formData.ver
                        userAdd(formData)
                            .then(
                                (res) =>
                                    this.$Message.success(
                                        this.$t('tips.add.success')
                                    ),
                                (err) => (options.closeModal = false)
                            )
                            .then((res) => next())
                    }
                } else {
                    options.closeModal = false
                    next()
                }
            })
        })

        // 在窗口显示前加载数据
        this.$modal.beforeEnter((next) => {
            Promise.all([this.fetch(), orgList(), this.fetchAssetsPark()])
                .then((args) => {
                    var [user, role, parkList] = args
                    this.orgOptions = role.data.list

                    if (user) {
                        var userData = user.data

                        Object.keys(this.pInfo).forEach(
                            (name) => (this.pInfo[name] = userData[name])
                        )
                    }
                    this.parkList = parkList
                })
                .finally(() => {
                    this.loading = false
                    next()
                })
        })
    },
}
</script>
